import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M16 12h3v-4h-5v-5h-4v3m-2 2h-3v4h5v9h4v-7","key":"svg-0"}],["path",{"d":"M3 3l18 18","key":"svg-1"}]]

const IconCrossOff = createReactComponent('outline', 'cross-off', 'CrossOff', __iconNode);

export default IconCrossOff;